module.exports = __webpack_public_path__ + "0aa97225b28339b0fccef2aa9f095756.svg";